//place custom scripts for admin

//have the 'check all' checkbox checked on load if all checkboxes of a given data id are checked
$(function () {
    $('.check-all').each(function () {
        var checked = true;
        $('.checkbox-' + $(this).data('id')).each(function () {
            if (!$(this).is(":checked")) {
                checked = false;
            }
        })
        $(this).prop('checked', checked)
    });
});

//highlight changed inputs of a given class
$(function () {
    $('.highlight-change').on('change', function () {
        $(this).css('border', '1px solid red');
    });

    $('.highlight-change-checkbox').on('change', function () {
        $(this).css('box-shadow', '0px 0px 0px 1px rgba(255,0,0,1)');
    });

    $('.highlight-select').on('select', function () {
        $(this).css('border', '1px solid red');
    });

    $('.highlight-click').on('click', function () {
        $(this).css('border', '1px solid red');
    });
});

// Keep the scroll position after submitting forms
document.addEventListener("DOMContentLoaded", function (event) {
    var scrollpos = sessionStorage.getItem('scrollpos');
    if (scrollpos) {
        window.scrollTo(0, scrollpos);
        sessionStorage.removeItem('scrollpos');
    }
});

window.addEventListener("beforeunload", function (e) {
    sessionStorage.setItem('scrollpos', window.scrollY);
});
// end Keep the scroll position after submitting forms
